"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CatalogServiceBase = exports.CatalogService = void 0;
var tslib_1 = require("tslib");
var env_1 = require("@wix/wix-vod-constants/env");
var common_1 = require("@wix/wix-vod-shared/common");
var CatalogService = /** @class */ (function () {
    function CatalogService(httpClient, baseUrlPath) {
        if (baseUrlPath === void 0) { baseUrlPath = ''; }
        this.httpClient = httpClient;
        this.baseUrlPath = baseUrlPath;
    }
    Object.defineProperty(CatalogService.prototype, "defaultOptions", {
        get: function () {
            var _a;
            var defaultOptions = {
                baseURL: this.getBaseUrl(),
                xsrfCookieName: 'non-existing-cookie',
                withCredentials: true,
            };
            var authHeader = (0, common_1.getAuthorizationToken)();
            if (authHeader) {
                defaultOptions.headers = tslib_1.__assign(tslib_1.__assign({}, ((_a = defaultOptions.headers) !== null && _a !== void 0 ? _a : {})), { Authorization: authHeader });
            }
            return defaultOptions;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CatalogService.prototype, "baseOrigin", {
        get: function () {
            return (0, common_1.isEditorX)()
                ? env_1.PRODUCTION_HOSTS.catalogEditorX
                : env_1.PRODUCTION_HOSTS.catalog;
        },
        enumerable: false,
        configurable: true
    });
    CatalogService.prototype.getBaseUrl = function () {
        return this.baseOrigin + this.baseUrlPath;
    };
    CatalogService.prototype.getRelativeBasePath = function () {
        var _a;
        return (_a = this.getBaseUrl()) !== null && _a !== void 0 ? _a : '';
    };
    CatalogService.prototype.request = function (requestOptions) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, this.httpClient.request(tslib_1.__assign(tslib_1.__assign({ baseURL: this.getBaseUrl() }, this.defaultOptions), requestOptions))];
            });
        });
    };
    CatalogService.prototype.post = function (url, data, requestOptions) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, this.httpClient.post(this.getRelativeBasePath() + url, data, tslib_1.__assign(tslib_1.__assign({}, this.defaultOptions), requestOptions))];
            });
        });
    };
    CatalogService.prototype.patch = function (url, data, requestOptions) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, this.httpClient.patch(this.getRelativeBasePath() + url, data, tslib_1.__assign(tslib_1.__assign({}, this.defaultOptions), requestOptions))];
            });
        });
    };
    CatalogService.prototype.put = function (url, data, requestOptions) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, this.httpClient.put(this.getRelativeBasePath() + url, data, tslib_1.__assign(tslib_1.__assign({}, this.defaultOptions), requestOptions))];
            });
        });
    };
    CatalogService.prototype.get = function (url, requestOptions) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, this.httpClient.get(this.getRelativeBasePath() + url, tslib_1.__assign(tslib_1.__assign({}, this.defaultOptions), requestOptions))];
            });
        });
    };
    CatalogService.prototype.delete = function (url, requestOptions) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, this.httpClient.delete(this.getRelativeBasePath() + url, tslib_1.__assign(tslib_1.__assign({}, this.defaultOptions), requestOptions))];
            });
        });
    };
    return CatalogService;
}());
exports.CatalogService = CatalogService;
var CatalogServiceBase = /** @class */ (function (_super) {
    tslib_1.__extends(CatalogServiceBase, _super);
    function CatalogServiceBase(httpClient, baseUrl, baseUrlPath) {
        var _this = _super.call(this, httpClient, baseUrlPath) || this;
        _this.baseUrl = baseUrl;
        return _this;
    }
    CatalogServiceBase.prototype.getBaseUrl = function () {
        if (this.baseUrl === undefined) {
            return _super.prototype.getBaseUrl.call(this);
        }
        try {
            return new URL(this.baseUrl).origin;
        }
        catch (err) {
            // the URL is relative, no need to set baseURL
            return undefined;
        }
    };
    CatalogServiceBase.prototype.getRelativeBasePath = function () {
        if (this.baseUrl === undefined) {
            return _super.prototype.getRelativeBasePath.call(this);
        }
        try {
            return new URL(this.baseUrl).pathname;
        }
        catch (err) {
            // passed url is relative, so we just return it
            return this.baseUrl;
        }
    };
    return CatalogServiceBase;
}(CatalogService));
exports.CatalogServiceBase = CatalogServiceBase;
//# sourceMappingURL=catalog-service.js.map